import { useEffect, useState } from "react";
import globalState, { GlobalState } from "../../globalState";
import { useIntl } from "react-intl";
import hookMessages from "../messages";
import { subscribeToChats } from "src/api/messagesApi";
import { Chat } from "myfitworld-model";
import { useMessagesProvider } from "src/providers/MessagesProvider";

function useLoadChats({userId }: {userId: string|undefined;}) {
  const { formatMessage } = useIntl();
  const {unreadCountMessages} = useMessagesProvider();
  const [allChats, setAllChats] = useState<Chat[]>([]);
  const [archivedChats, setArchivedChats] = useState<Chat[]>([]);
  const [notArchivedChats, setNotArchivedChats] = useState<Chat[]>([]);
  const [refreshChats, setRefreshChats] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!userId) return;
    setIsLoading(true);
    const unsubscribe = subscribeToChats(userId, (newChats: Chat[]) => {
      setAllChats(newChats.reverse());

      const archivedChats = newChats.filter(chat => 
        (chat.userFirstData.id === userId && chat.userFirstData.archived && (!chat.userFirstData.deleted || (chat.userFirstData.deletedDate && chat.userFirstData.deletedDate.getTime() < chat.lastMessageData.createdAt.getTime()))) ||
        (chat.userSecondData.id === userId && chat.userSecondData.archived && (!chat.userSecondData.deleted || (chat.userSecondData.deletedDate && chat.userSecondData.deletedDate.getTime() < chat.lastMessageData.createdAt.getTime()))
      ));
  
      const notArchivedChats = newChats.filter(chat =>
        (chat.userFirstData.id === userId && !chat.userFirstData.archived && (!chat.userFirstData.deleted || (chat.userFirstData.deletedDate && chat.userFirstData.deletedDate.getTime() < chat.lastMessageData.createdAt.getTime()))) ||
        (chat.userSecondData.id === userId && !chat.userSecondData.archived && (!chat.userSecondData.deleted  || (chat.userSecondData.deletedDate && chat.userSecondData.deletedDate.getTime() < chat.lastMessageData.createdAt.getTime())))
      );
  
      setArchivedChats(archivedChats.reverse());
      setNotArchivedChats(notArchivedChats.reverse());
      setIsLoading(false);
    }, onCatchError);
    return () => unsubscribe?.();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, unreadCountMessages, refreshChats]);
  

  const onCatchError = () => {
    setIsLoading(false);
    globalState.update((state: GlobalState) => {
      state.toastQueue.push({
        message: formatMessage(hookMessages.error_loading_messages),
        severity: "error",
      });
    });
  }

  return {
    allChats,
    archivedChats,
    notArchivedChats,
    isLoading,
    setRefreshChats
  };
}

export default useLoadChats;
